import { useMemo } from "react";

import { useToken } from "@hightouch/htui";

import type { DotFieldEffect } from "src/components/preview-canvas/dot-field";
import {
  type DotGrid,
  dotGridBackground,
} from "src/components/preview-canvas/dot-grid";

/** The canvas's dot grid: a faint 2px dot every 24px, in `text.primary`. */
export function useCanvasDotGrid(): DotGrid {
  // The token's value, not its CSS variable: an editor's backdrop draws the grid as an image, which can't read one.
  const color = useToken("colors", "text.primary");
  return useMemo(() => ({ step: 24, size: 2, color, opacity: 0.2 }), [color]);
}

/** The grid at zoom 1, as an inline `style` for a ground that doesn't pan or zoom. */
export function useCanvasDotGridGround() {
  const grid = useCanvasDotGrid();
  return useMemo(() => dotGridBackground(grid), [grid]);
}

/** How the grid answers a file an agent is working on, as tuned on the prototype. */
export const CANVAS_WORK_FIELD: DotFieldEffect = {
  period: 8,
  reach: 56,
  intensity: 1.15,
  morph: 2.7,
  floor: 0.3,
  opacity: 0.56,
  grow: 1.85,
  color: "var(--chakra-colors-text-tertiary)",
};
